import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import Home from './views/Home.vue';

Vue.use(Router);

// for public
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.tokenscr) {
    next();
    return;
  } else {
    next('/');
  }
};
// for user
const ifAuthenticated = (to, from, next) => {
  if (store.getters.tokenscr) {
    next();
    return;
  }
  next('/login');
};
// for user
const ifAuthenticatedUser = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'user') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for company
const ifAuthenticatedCompany = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'company') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for jobseeker
const ifAuthenticatedJs = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'jobseeker') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for admin
const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'admin') {
      next();
      return;
    } else {
      next('/atlet/detail');
    }
  }
  next('/login');
};
// for dosen
const ifAuthenticatedDosen = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'dosen') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for mahasiswa
const ifAuthenticatedMhs = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'mahasiswa') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: () => import('./views/Landing.vue'),
    },
    {
      path: '/verifyuser',
      name: 'Verifyuser',
      component: () => import('./views/Verifyuser.vue'),
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/About.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/registration',
      name: 'Register',
      component: () => import('./views/Register.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/forget-password',
      name: 'Forgetpass',
      component: () => import('./views/Forgetpass.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/reset-password',
      name: 'Resetpass',
      component: () => import('./views/Resetpass.vue'),
    },
    {
      path: '/change-password',
      name: 'Changepassword',
      component: () => import('./views/Changepass.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/join-class',
      name: 'Joinclass',
      component: () => import('./views/users/Joinclass.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/list-class',
      name: 'Listclass',
      component: () => import('./views/users/Listclass.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/class/detail',
      name: 'Detailclass',
      component: () => import('./views/users/Detailclass.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/class/detail/work',
      name: 'Detailclasswork',
      component: () => import('./views/users/Detailclasswork.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/class/detail/people',
      name: 'Detailclasspeople',
      component: () => import('./views/users/Detailclasspeople.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/class/detail/grade',
      name: 'Detailclassgrade',
      component: () => import('./views/users/Detailclassgrade.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/dosen/create-class',
      name: 'CreateclassDosen',
      component: () => import('./views/teacher/Createclass.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/list-class',
      name: 'ListclassDosen',
      component: () => import('./views/teacher/Listclass.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/archive-class',
      name: 'ArchiveclassDosen',
      component: () => import('./views/teacher/Archiveclass.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/another-absence',
      name: 'OtherAbsence',
      component: () => import('./views/teacher/OtherAbsence.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/class/detail',
      name: 'DetailclassDosen',
      component: () => import('./views/teacher/Detailclass.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/class/detail/work',
      name: 'DetailclassworkDosen',
      component: () => import('./views/teacher/Detailclasswork.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/class/detail/people',
      name: 'DetailclasspeopleDosen',
      component: () => import('./views/teacher/Detailclasspeople.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/class/detail/grade',
      name: 'DetailclassgradeDosen',
      component: () => import('./views/teacher/Detailclassgrade.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/post/materi',
      name: 'DetailpostmateriDosen',
      component: () => import('./views/teacher/Detailpostmateri.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/post/tugas',
      name: 'DetailposttugasDosen',
      component: () => import('./views/teacher/Detailposttugas.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/tugas/kumpul',
      name: 'DetailtugaskumpulDosen',
      component: () => import('./views/teacher/Detailtugaskumpul.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/profile',
      name: 'ProfileDosen',
      component: () => import('./views/teacher/Profiledosen.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/invite/mahasiswa',
      name: 'Invitemahasiswa',
      component: () => import('./views/student/Invite.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/invite/dosen',
      name: 'Invitedosen',
      component: () => import('./views/teacher/Invite.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/mahasiswa/join-class',
      name: 'JoinclassMhs',
      component: () => import('./views/student/Joinclass.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/list-class',
      name: 'ListclassMhs',
      component: () => import('./views/student/Listclass.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/class/detail',
      name: 'DetailclassMhs',
      component: () => import('./views/student/Detailclass.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/class/detail/work',
      name: 'DetailclassworkMhs',
      component: () => import('./views/student/Detailclasswork.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/class/detail/people',
      name: 'DetailclasspeopleMhs',
      component: () => import('./views/student/Detailclasspeople.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/class/detail/grade',
      name: 'DetailclassgradeMhs',
      component: () => import('./views/student/Detailclassgrade.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/class/detail/absen',
      name: 'DetailclassabsenMhs',
      component: () => import('./views/student/Detailclassabsen.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/post/materi',
      name: 'DetailpostmateriMhs',
      component: () => import('./views/student/Detailpostmateri.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/post/tugas',
      name: 'DetailposttugasMhs',
      component: () => import('./views/student/Detailposttugas.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/tugas/kumpul',
      name: 'DetailtugaskumpulMhs',
      component: () => import('./views/student/Detailtugaskumpul.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/profile',
      name: 'ProfileMhs',
      component: () => import('./views/student/Profilemhs.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '/mahasiswa/surat/list',
      name: 'SuratListMhs',
      component: () => import('./views/student/surat/Listsurat.vue'),
      beforeEnter: ifAuthenticatedMhs,
    },
    {
      path: '*',
      name: 'Notfound',
      component: () => import('./views/Notfound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
